export const CANCEL_APPOINTMENT_ID = 'cancelAppointmentId';
